import React, {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Button, Icon, Modal, Grid, Input} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';

const {
  changeWtsCourseAreaSelected,
  createWtsCoursesArea,
  updateWtsCoursesArea,
} = Actions;

const WtsCourseAreasModal = ({mode, courseAreaToEdit}) => {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const areaSelected = useSelector((state) => state.wtsAreas.areaSelected);
  const courseAreaSelected = useSelector((state) => state.wtsCoursesAreas.coursesAreaSelected);
  const coursesAreas = useSelector((state) => state.wtsCoursesAreas.coursesAreas || []);

  const getNextId = () => {
    if (mode === 'edit') {
      return courseAreaToEdit.id;
    }
    const ids = coursesAreas.map((item) => parseInt(item.id, 10)).filter((id) => !isNaN(id));
    const maxId = ids.length > 0 ? Math.max(...ids) : 0;
    return maxId + 1;
  };

  const onChangeValues = (value, field) => {
    const changedCourseAreaSelected = {...courseAreaSelected, [field]: value.toUpperCase()};
    dispatch(changeWtsCourseAreaSelected(changedCourseAreaSelected));
  };

  const showCourseStatusModal = (e, value) => {
    e.preventDefault();
    setShowModal(value);
    if (mode === 'edit') {
      dispatch(changeWtsCourseAreaSelected({
        ...courseAreaToEdit,
        'sequence': courseAreaToEdit.sequence || 0,
      }));
    } else {
      dispatch(changeWtsCourseAreaSelected({
        'sequence': 0,
        'course_area': '',
      }));
    }
  };

  const saveCourseArea = (e) => {
    e.preventDefault();
    if (mode === 'new') {
      dispatch(createWtsCoursesArea(areaSelected.id, {'data': courseAreaSelected}));
    } else {
      dispatch(updateWtsCoursesArea(areaSelected.id, {'data': courseAreaSelected}));
    }
    showCourseStatusModal(e, false);
  };

  return (
    <Modal size='tiny' closeOnEscape={false} closeOnDimmerClick={false}
      open={showModal}
      trigger={
        mode === 'new' ?
          <Button compact content="Añadir"
            icon={<Icon name='add-circle' size='big' color='green' />}
            onClick={(e) => showCourseStatusModal(e, true)} /> :
          <Icon link name='pencil' size='big' onClick={(e) => showCourseStatusModal(e, true)} color='green' />
      }>
      <Modal.Header>
        <div className='header flex'>
          <h2 className='flex grow' style={{'margin': 0}}>
            {mode === 'new' ? 'Crear Área' : 'Editar Área'}
          </h2>
          <Icon className='download' name='close' style={{'margin': 0, 'cursor': 'pointer'}}
            onClick={(e) => showCourseStatusModal(e, false)} />
        </div>
      </Modal.Header>
      <Modal.Content>
        <Grid stackable stretched>
          <Grid.Row>
            <Grid.Column width={6}>
              <Input fluid
                label="Código"
                value={getNextId()}
                disabled={true}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Input fluid
                label="Área"
                value={courseAreaSelected?.course_area || ''}
                onChange={(e, {value}) => onChangeValues(value, 'course_area')}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Modal.Content>
      <Modal.Actions>
        <Button positive compact icon='save' onClick={(e) => saveCourseArea(e)}>Guardar</Button>
      </Modal.Actions>
    </Modal>
  );
};

export default WtsCourseAreasModal;
